module.exports = __webpack_public_path__ + "static/media/arrived.c3afaef8.png";